<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style lang="scss" scoped>
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_17.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>small RNA测序</h1>-->
<!--          <h2 class="mt10">small RNA sequencing</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>small RNA测序</h1>
      <h2 class="mt10">Small RNA Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">Small RNA测序是研究某物种某组织在特定时空状态下18 ～ 30 nt的small RNA片段序列信息，实现精准定量，通过与数据库比对, 可实现small RNA序列的鉴定、靶基因分析和功能分析， 以及包含miRNA、siRNA、piRNA等多种small RNA类型的分析研究需求等。主要应用在动植物生长发育调控研究、抗病抗逆调控研究、生物性状及突变调控研究等；在疾病研究方面，可研究疾病发生调控机制、寻找生物标记、靶向药物研究等。</p>
      <div class="c-title">应用领域</div>
      <div class="con">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/small_icon_1.png">
            <p>基因转录后调控研究</p>
          </li>
          <li>
            <img src="@/assets/images/small_icon_2.png">
            <p>基因沉默研究</p>
          </li>
          <li>
            <img src="@/assets/images/small_icon_3.png">
            <p>small RNA靶标分析和调控网络</p>
          </li>
        </ul>
      </div>
      <div class="cons" style="margin-top: 20px;">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/small_icon_1.png">
            <p>基因转录后调控研究</p>
          </li>
          <li>
            <img src="@/assets/images/small_icon_2.png">
            <p>基因沉默研究</p>
          </li>
          <li>
            <img src="@/assets/images/small_icon_3.png">
            <p>small RNA靶标分析和调控网络</p>
          </li>
        </ul>
      </div>
      <div class="c-title">技术参数</div>
      <ul class="lists">
        <li>
          <img src="@/assets/images/prokaryotic_icon_4.png">
          <h4>测序平台及策略</h4>
          <p>HiSeq/NovaseqSE50/SE75</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_5.png">
          <h4>项目周期</h4>
          <p>45个工作日</p>
        </li>
        <!-- <li>
          <img src="@/assets/images/prokaryotic_icon_6.png">
          <h4>测量数据量</h4>
          <p>10 M Reads</p>
        </li> -->
        <li>
          <img src="@/assets/images/prokaryotic_icon_7.png">
          <h4>数据质量</h4>
          <p>Q30 > 80%</p>
        </li>
      </ul>
      <div class="c-title">技术路线</div>
      <div class="tc con"><img src="@/assets/images/small_1.png"> </div>
      <div class="tc cons" style="margin-top: 20px;"><img src="@/assets/images/small_1.png"> </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/smallRNA.vue